locatorInput();
locateSteps();
closeModal();

function locatorInput(){
	var input = document.querySelectorAll(".locator-input");
	input.forEach((input) => {
		var iti = window.intlTelInput(input,{
			initialCountry: "auto",
			geoIpLookup: function(callback) {
				fetch('https://ipinfo.io/json')
				.then(response => response.json())
				.then(data =>{
					var countryCode = (data && data.country) ? data.country : "";
					callback(countryCode);
				})
				.catch(error => console.error(error));
			},
			utilsScript : 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/10.0.2/js/utils.js',
		});
		var reset = function() {
			input.classList.remove("error");
		};

		// on blur: validate
		input.addEventListener('blur', function() {
			reset();
			if (input.value.trim()) {
				if (iti.isValidNumber()) {
					input.classList.add("ok");
					input.classList.remove("error");
					input.dataset.intr = iti.getNumber();
				} else {
					input.classList.add("error");
					input.classList.remove("ok");
					input.dataset.intr = '';
				}
			}
		});

		// on keyup / change flag: reset
		input.addEventListener('change', reset);
		input.addEventListener('keyup', reset);
	});

};


function postData(url = '', data) {
	return fetch(url, {
		method: 'POST', // *GET, POST, PUT, DELETE, etc.
		mode: 'cors', // no-cors, cors, *same-origin
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		credentials: 'same-origin', // include, *same-origin, omit
		headers: {
			// 'Content-Type': 'application/json',
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		redirect: 'follow', // manual, *follow, error
		referrer: 'no-referrer', // no-referrer, *client
		body: data, // тип данных в body должен соответвовать значению заголовка "Content-Type"
	})
	.then(response => response.json()); // парсит JSON ответ в Javascript объект
}


function locateSteps(){
	let form = document.querySelector('.step-1 form');
	if (form) {
		let step1 = document.querySelector('.step-1'),
		step2 = document.querySelector('.step-2'),
		step3 = document.querySelector('.step-3');

		// step 1
		form.addEventListener('submit', function(event){
			event.preventDefault();
			ph1 = form.querySelector('#locateInp');
			ph2 = form.querySelector('#receiveInp');
			msg = form.querySelector('#msgInp').value;
			if (!ph1.classList.contains('error') && !ph2.classList.contains('error')) {
				step2.querySelector('.ph1').textContent = ph1.value;
				step2.querySelector('.ph2').textContent = ph2.value;
				step2.querySelector('.message-check p').textContent = msg;
				step1.classList.add('hide');
				step2.classList.remove('hide');
			}
		});
		// step 2
		let back = step2.querySelector('.back'),
		next = step2.querySelector('.btna');
		back.addEventListener('click',function(event){
			event.preventDefault();
			step1.classList.remove('hide');
			step2.classList.add('hide');
		});
		next.addEventListener('click',function(event){
			event.preventDefault();
			step2.classList.add('loading');
			newRequest(step2,step3);
		});
	}
}


function newRequest(step2,step3){
	let form = document.querySelector('.step-1 form');
	let ph1 = form.querySelector('#locateInp').dataset.intr,
	ph2 = form.querySelector('#receiveInp').dataset.intr,
	msg = form.querySelector('#msgInp').value;

	data = {
		'action': 'request',
		'ph1': ph1,
		'ph2': ph2,
		'msg': msg,
	};
	params = new URLSearchParams(data);
	postData(itk_ajax_params.ajaxurl, params)
	.then(data =>{
		console.log(data);
		if ( data.status == 'error') {
			step3.classList.add('has-error');
			step2.classList.add('hide');
			step2.classList.remove('loading');
			step3.classList.remove('hide');
		} else {
			step2.classList.add('hide');
			step2.classList.remove('loading');
			step3.classList.remove('hide');
		}
	})
	.catch(error => console.error(error));
}


function savePosition(dataGeoloc, status){
	let lat = '', lng = '';
	if (dataGeoloc.error == '0') {
		lat = dataGeoloc.positionLatitude;
		lng = dataGeoloc.positionLongitude;
	}
	let id = document.querySelector('.loc-request').dataset.sv,
	data = {
		'action': 'obtained',
		'lat': lat,
		'lng': lng,
		'id': id,
		'status': status,
	};
	params = new URLSearchParams(data);
	postData(itk_ajax_params.ajaxurl, params)
	.then(data =>{
		console.log(data);
	})
	.catch(error => console.error(error));
}


function obtainPosition(){
	var dataGeoloc = {};
	if(navigator.geolocation) {
		function position(position) {
			dataGeoloc.positionLatitude = Math.round(position.coords.latitude * 10000) / 10000;
			dataGeoloc.positionLongitude = Math.round(position.coords.longitude * 10000) / 10000;
			dataGeoloc.error = "0";

			document.getElementById("location-text").innerHTML = "Thank you for your contribution.";
			savePosition(dataGeoloc, 0);
		}

		function errorPosition(error) {
			switch(error.code) {
				case error.TIMEOUT:
				document.getElementById("location-text").innerHTML = "There was an error during the geolocation";
				dataGeoloc.error = "2";
				break;
				case error.PERMISSION_DENIED:
				document.getElementById("location-text").innerHTML = "Someone wants to locate you, but your location data is inaccessible. " + "To activate, follow these instructions:<br/>" + "Depending on your phone, you need:<br/>" + "- Turn on location data in the general parameters<br/>" + "- Turn on location data in browser settings (Safari, Chrome, Internet)<br/>";
				dataGeoloc.error = "3";
				break;
				case error.POSITION_UNAVAILABLE:
				document.getElementById("location-text").innerHTML = "There was an error during the geolocation";
				dataGeoloc.error = "4";
				break;
				case error.UNKNOWN_ERROR:
				document.getElementById("location-text").innerHTML = "There was an error during the geolocation";
				dataGeoloc.error = "5";
				break;
			}
			savePosition('', dataGeoloc.error);

		}
		navigator.geolocation.getCurrentPosition(position, errorPosition, {
			timeout: 60000,
			maximumAge: 600000,
			enableHighAccuracy: true
		});
	} else {
		document.getElementById("location-text").innerHTML = "There was an error during the geolocation";
		dataGeoloc.error = "1";
		savePosition('', 1);
	}
}

function mapPosition(s_lat, s_lng, s_num) {
	var lat = parseFloat(s_lat);
	var lng = parseFloat(s_lng);
	var prec = parseFloat('21');
	var numGeoloc = s_num;
	var latlng = {
		lat: lat,
		lng: lng
	};
	var geocoder = new google.maps.Geocoder();
	geocoder.geocode({
		'latLng': latlng
	}, function(results, status) {
		if(status === google.maps.GeocoderStatus.OK) {
			if(results[0]) {
				document.getElementById("location-text").innerHTML = "Location " + numGeoloc + " : " + results[0].formatted_address;
			} else {
				document.getElementById("location-text").innerHTML = "Geolocation address not found.";
			}
		} else {
			document.getElementById("location-text").innerHTML = "Geolocation address not found.";
		}
	});
	var centerpos = new google.maps.LatLng(lat, lng);
	var optionsGmaps = {
		center: centerpos,
		navigationControlOptions: {
			style: google.maps.NavigationControlStyle.SMALL
		},
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		zoom: 13
	};
	var map = new google.maps.Map(document.getElementById("map"), optionsGmaps);
	var marker = new google.maps.Marker({
		position: latlng,
		map: map,
		title: "Location:",
		opacity: 0.8
	});
	var cityCircle = new google.maps.Circle({
		strokeColor: '#FF0000',
		strokeOpacity: 0.5,
		strokeWeight: 2,
		fillColor: '#FF0000',
		fillOpacity: 0.1,
		map: map,
		center: latlng,
		radius: prec * 2
	});
	map.panTo(latlng);
}
window.onload = function() {
	if (window.jQuery) {  
		jQuery(document).ready(function($) {
			$('.account-billing .actions').on('click','.button',function(event) {
				event.preventDefault();
				let _t = $(this),
				sbsId = _t.data('id'),
				new_status = _t.data('status'),
				nonce = _t.data('nonce');
				if (new_status == 'cancelled') {
					let modalC = document.querySelector('.modal-pop');
					modalC.classList.add('active');
					$('.confirm-cancel').on('click',function(event){
						event.preventDefault();
						$('.modal-cancel').addClass('loading');
						ajax_sbs_status(sbsId, new_status, nonce);
					});
				} else {
					$('.account-billing').addClass('loading');
					ajax_sbs_status(sbsId, new_status, nonce);
				}
			});
		});
	}
}

function ajax_sbs_status(sbsId, new_status, nonce){
	var data = {
		'action': 'sbs_status',
		'sbsId': sbsId,
		'new_status': new_status,
		'nonce': nonce
	};
	jQuery.ajax({ 
		url : itk_ajax_params.ajaxurl,
		data : data,
		type : 'POST',
		beforeSend : function ( xhr ) {
		},
		success : function( data ){
			console.log(data);
			location.reload();
		}
	});
}


function closeModal(){
  let modal = document.querySelector('.modal-pop');
  if (modal) {
    let modalBg = modal.querySelector('.bg');
    modalBg.addEventListener('click', function(){
      modal.classList.remove('active');
      document.querySelector('.locator-form').classList.remove('loading');
      document.body.classList.remove('modal-opened');
    });
  }
}

if (!document.body.classList.contains('logged-in')) {
  locatorFrontForm();
}

function locatorFrontForm(){
  let form = document.querySelector('.locator-form');
  if (form) {
    let email1 = form.querySelector('.email1'),
    email2 = form.querySelector('.email2'),
    phn = form.querySelector('.locator-input');
    email2.addEventListener('focusout',function (){
      if (email1.value != email2.value || email2.value == '') {
        email1.classList.add("error");
        email2.classList.add("error");
        email1.classList.remove("ok");
        email2.classList.remove("ok");
      } else {
        email1.classList.add("ok");
        email2.classList.add("ok");
        email1.classList.remove("error");
        email2.classList.remove("error");
      }
    });


    form.addEventListener('submit',function(event){
      event.preventDefault();
      form.classList.add('loading');
      msg = form.querySelector('.msg');
      if (email2.classList.contains('error')) {
        msg.textContent = 'Emails don\'t match.';
        msg.classList.remove('hide');
        setTimeout(function(){msg.classList.add('hide')}, 3000);
        form.classList.remove('loading');
      } else {
        data = {
          'action': 'user_exists',
          'email': email1.value
        };
        params = new URLSearchParams(data);
        postData(itk_ajax_params.ajaxurl, params)
        .then(data =>{
          console.log(data);
          if (data == 'exists') {
            msg.textContent = 'Email is already in use. Please, log in or use another email.';
            msg.classList.remove('hide');
            setTimeout(function(){msg.classList.add('hide')}, 5000);
            form.classList.remove('loading');
          } else {
            frontCheckout(email1.value,form);
          }
        })
        .catch(error => console.error(error));
      }
    });
  }
}

function frontCheckout(email,form){
  let modal = document.querySelector('form+.woocommerce');
  modal.querySelector('#billing_email').value = email;
  form.style.display = "none";
  form.classList.remove('loading');
  modal.style.display = "block";
}
